import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/UI'
import { materialCalculatorApi } from '../../services/materialCalculator'
import MCRunVersionSelector from './components/MCRunVersionSelector'
import MCCompareRunsView from './components/MCCompareRunsView'
import MCBoQTable from './components/MCBoQTable'

export default function MCReportsPage() {
  const { projectId } = useParams()
  const [runs, setRuns] = useState([])
  const [leftId, setLeftId] = useState('')
  const [rightId, setRightId] = useState('')

  useEffect(() => {
    materialCalculatorApi.listRuns(projectId).then((data) => {
      setRuns(data)
      if (data[0]) setLeftId(data[0].id)
      if (data[1]) setRightId(data[1].id)
    }).catch(() => setRuns([]))
  }, [projectId])

  const left = useMemo(() => runs.find((r) => r.id === leftId), [runs, leftId])
  const right = useMemo(() => runs.find((r) => r.id === rightId), [runs, rightId])

  const boqItems = useMemo(() => {
    if (!left?.resultsJson) return []
    const data = JSON.parse(left.resultsJson)
    return Object.entries(data).map(([material, quantity]) => ({ chapter: 'General', material, unit: '-', quantity: Number(quantity).toFixed(2) }))
  }, [left])

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Reportes</CardTitle>
          <CardDescription>Selecciona una versión de cálculo y compara corridas.</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-wrap gap-2">
          <MCRunVersionSelector runs={runs} value={leftId} onChange={setLeftId} />
          <MCRunVersionSelector runs={runs} value={rightId} onChange={setRightId} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Cómputo general</CardTitle></CardHeader>
        <CardContent><MCBoQTable items={boqItems} /></CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Comparar versiones</CardTitle></CardHeader>
        <CardContent><MCCompareRunsView left={left} right={right} /></CardContent>
      </Card>
    </div>
  )
}
